import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsStrip from "@/pages/home/components/StatsStrip";
import TopicWall from "@/pages/home/components/TopicWall";
import LatestLeaks from "@/pages/home/components/LatestLeaks";
import HotRanking from "@/pages/home/components/HotRanking";
import ResourceEntries from "@/pages/home/components/ResourceEntries";
import ControversyReview from "@/pages/home/components/ControversyReview";
import DiscussionBoard from "@/pages/home/components/DiscussionBoard";
import SubscribeBar from "@/pages/home/components/SubscribeBar";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <StatsStrip />
        <TopicWall />
        <LatestLeaks />
        <HotRanking />
        <ResourceEntries />
        <ControversyReview />
        <DiscussionBoard />
        <SubscribeBar />
      </main>
      <SiteFooter />
    </div>
  );
}